import React from 'react';
import PropTypes from 'prop-types';
import ExportTabTooltipHeader from './ExportTabTooltipHeader';
import ExportTabTooltipContent from './ExportTabTooltipContent';
import ExportTabTooltipFooter from './ExportTabTooltipFooter';

import './ExportTabTooltip.custom.scss';
import './ExportTabTooltip.theme.scss';

function ExportTabTooltip(props) {
  const { exportResult } = props;
  if (!exportResult) {
    return null;
  }
  return (
    <div className="exportTab__tooltip">
      <ExportTabTooltipHeader {...props} />
      <ExportTabTooltipContent {...props} />
      <ExportTabTooltipFooter {...props} />
    </div>
  );
}

ExportTabTooltip.propTypes = {
  exportResult: PropTypes.object,
};

export default ExportTabTooltip;
